module.exports = __webpack_public_path__ + "img/2269e2b770dc53556a8c48fee4a407a9.png";